<template>
	<div class="leftres">
		<div>
			<div :class=" showorhide ? 'inputtop' : 'inputtops' ">
				<div v-for="(item , index) of formdata" :key="index" style="display: inline-block;">
					<Commondropdownlist ref="distriRef" :options="item.options" :lablewith="item.lablewith"
						:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width" :event="item.event" @invClassChage="invClassChage"></Commondropdownlist>
				</div>
				<div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
					<CommonBtngroup :show="showorhide" :qhide="false" @showclick="showclick" @hide="hide"
						@select="select" @reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;">
				</div>
			</div>
			<div class="TableBox"
				style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<Distributorpurchaseinboundreporttable :loading="false" :tableData="tableData" :total="total"
					@Export="Export" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
				</Distributorpurchaseinboundreporttable>
			</div>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from '../../../components/common-dropdownlist.vue'
	import CommonBtngroup from '../../../components/commongroup.vue'
	import Dialog from '../../../components/dialog.vue'
	import Distributorpurchaseinboundreporttable from './components/distributorpurchaseinboundreporttable.vue'
	import utils from '../../../common/utils'
	import {
		WMSReportASNReportList,
		WMSReportASNReportExport,
		InventoryClassList,
		Status,
		ASNVoucherType,
		GetProvince
	} from '@/api/home'
	import {
		GetLevel3List
	} from '@/api/newsapi'
	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			Dialog,
			Distributorpurchaseinboundreporttable,
		},
		data() {
			return {
				total: 1,
				pageindex: 1,
				pageSize: 20,
				tableData: [],
				dialogVisibles: false,
				showorhide: true,
				formdata: [{
						inputdata: '',
						title: '经销商类型',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'select',
						width: '210px',
						options: [{
							value: '一级经销商',
							key: '1'
						}, {
							value: '二级经销商',
							key: '2'
						}, ],
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '经销商名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '100px'
					},
					{
						inputdata: "",
						title: "创建日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "140px",
					},
					{
						inputdata: '',
						title: '产品线',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'selectMultiple',
						width: '210px',
						options: [],
						event: 'invClassChage'
					},
					{
						inputdata: '',
						title: '产品型号/名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '100px'
					},


					{
						inputdata: '',
						title: '单据类型',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '210px',
						lablewith: '100px',
						options: [

						]
					},
					{
						inputdata: "",
						title: "审核日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "140px",
					},
					{
						inputdata: '',
						title: '批号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '80px'
					},
					{
						inputdata: '',
						title: '状态',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'select',
						width: '210px',
						lablewith: '100px',
						options: []
					},
					{
						inputdata: '',
						title: '省份',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'selectMultiple',
						width: '210px',
						options: [],
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '销售',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '80px'
					},
					{
						inputdata: '',
						title: '入库单号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '80px'
					},
					{
						inputdata: '',
						title: '出库方',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: 'L3',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'selectMultiple',
						width: '210px',
						options: []
					},
				],
				from: {
					cusGrade: "",
					createOrgName: "",
					vouCode: "",
					createTime1: "",
					createTime2: "",
					invClass: "",
					inventory: "",
					voucherType: "",
					verifyTime1: "",
					verifyTime2: "",
					dpDate1: "",
					dpDate2: "",
					Batch: "",
					status: "",
					ProvinceID: '',
					SalesMan: "",
					OCompanyName: "",
					Level3Code: ""
				}
			}
		},
		mounted() {
			this.$message.warning("请填写搜索条件！");
			//this.wMSReportASNReportList()
			this.$refs.distriRef[2].startTime = this.$utils.getFYearDate();
			this.inventoryClassList()
			this.aSNVoucherType()
			this.status()
			this.getProvince();
		},
		methods: {
			invClassChage(e) {
				this.from.invClass = e.modelvalue ? e.modelvalue.join(',') : ''
				if (this.$refs.distriRef[13]) {
					this.$refs.distriRef[13].modelvalue = ''
				}
				this.from.Level3Code = ''
				this.getLevel3List()
			},
			async getLevel3List() {
				if (!this.from.invClass) {
					this.formdata[13].options = []
					return
				}
				let {
					code,
					data
				} = await GetLevel3List({
					InvClass: this.from.invClass
				})
				if (code == 0) {
					this.formdata[13].options = []
					data.map(item => {
						this.formdata[13].options.push({
							key: item.value || item.Value,
							value: item.key || item.Text
						})
					})
				} else {
					this.formdata[13].options = []
				}
			},
			//省份列表
			async getProvince() {
				let {
					data,
					code,
					message
				} = await GetProvince({})
				console.log(data, '省');
				if (code == 0) {
					this.formdata[9].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.formdata[9].options.push(obj)
					})

				} else {
					this.$message({
						type: 'error',
						message: "省份列表加载失败"
					})
				}
			},
			// 单据类型下拉
			async aSNVoucherType() {
				let {
					code,
					data
				} = await ASNVoucherType({})
				if (code == 0) {
					this.formdata[5].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.formdata[5].options.push(obj)
					})
				}
			},
			// 获取产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({

				})
				if (code == 0) {
					try {
						this.formdata[3].options = []
						data.data.map((item, index) => {
							let obj = {
								key: item.InvClass,
								value: item.InvClassName
							}
							this.formdata[3].options.push(obj)
						})
					} catch (error) {}
				}
			},
			// 状态下拉
			async status() {
				let {
					code,
					data
				} = await Status({})
				if (code == 0) {
					this.formdata[8].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.formdata[8].options.push(obj)
					})

				}
			},
			// 列表
			async wMSReportASNReportList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				let {
					data,
					code
				} = await WMSReportASNReportList({
					CusGrade: Number(this.from.cusGrade),
					CreateOrgName: this.from.createOrgName,
					VouCode: this.from.vouCode,
					CreateTime1: this.from.createTime1,
					CreateTime2: this.from.createTime2,
					InvClass: this.from.invClass,
					Inventory: this.from.inventory,
					VoucherType: this.from.voucherType,
					VerifyTime1: this.from.verifyTime1,
					VerifyTime2: this.from.verifyTime2,
					Batch: this.from.Batch,
					ProvinceIDs: this.from.ProvinceID,
					Level3Code: this.from.Level3Code,
					SalesMan: this.from.SalesMan,
					status: this.from.status,
					OCompanyName: this.from.OCompanyName,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				//console.log(code, data.data)
				if (code == 0) {
					this.total = data.Count
					if (data.data) {
						this.tableData = data.data
					}
					loading.close();
				}
				loading.close();
			},
			// 导出
			async wMSReportASNReportExport() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await WMSReportASNReportExport({
					CusGrade: Number(this.from.cusGrade),
					CreateOrgName: this.from.createOrgName,
					VouCode: this.from.vouCode,
					CreateTime1: this.from.createTime1,
					CreateTime2: this.from.createTime2,
					InvClass: this.from.invClass,
					Inventory: this.from.inventory,
					VoucherType: this.from.voucherType,
					VerifyTime1: this.from.verifyTime1,
					VerifyTime2: this.from.verifyTime2,
					Batch: this.from.Batch,
					ProvinceIDs: this.from.ProvinceID,
					Level3Code: this.from.Level3Code,
					SalesMan: this.from.SalesMan,
					status: this.from.status,
					OCompanyName: this.from.OCompanyName,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `经销商采购入库导出${str}`, "xlsx")
					loading.close();
				} else {
					// 返回json
					this.$message.warning('导出失败');
					loading.close();
				}
				loading.close()
			},
			// 导出
			Export() {
				this.wMSReportASNReportExport()
			},
			// 清空
			reset() {
				this.$refs.distriRef.map((item, index) => {
					if (index == 2 || index == 5) {
						item.startTime = ''
						item.endTime = ''
					} else {
						item.modelvalue = ''
					}
				})

			},
			hide() {
				this.showorhide = false
			},
			showclick() {
				this.showorhide = true
			},
			select() {
				this.pageindex = 1
				try {
					this.from.cusGrade = this.$refs.distriRef[0].modelvalue
					this.from.createOrgName = this.$refs.distriRef[1].modelvalue
					this.from.createTime1 = this.$refs.distriRef[2].startTime
					this.from.createTime2 = this.$refs.distriRef[2].endTime
					this.from.invClass = this.$refs.distriRef[3].modelvalue ? this.$refs.distriRef[3].modelvalue.join(
						',') : ''
					this.from.inventory = this.$refs.distriRef[4].modelvalue
					this.from.voucherType = this.$refs.distriRef[5].modelvalue
					this.from.verifyTime1 = this.$refs.distriRef[6].startTime
					this.from.verifyTime2 = this.$refs.distriRef[6].endTime
					this.from.Batch = this.$refs.distriRef[7].modelvalue
					this.from.status = this.$refs.distriRef[8].modelvalue
					this.from.ProvinceID = this.$refs.distriRef[9].modelvalue ? this.$refs.distriRef[9].modelvalue.join(
						',') : ''
					this.from.SalesMan = this.$refs.distriRef[10].modelvalue
					this.from.vouCode = this.$refs.distriRef[11].modelvalue
					this.from.OCompanyName = this.$refs.distriRef[12].modelvalue
					this.from.Level3Code = this.$refs.distriRef[13].modelvalue ? this.$refs.distriRef[13].modelvalue.join(
						',') : ''
					this.wMSReportASNReportList()
				} catch (error) {
					this.wMSReportASNReportList()
				}
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex
				this.wMSReportASNReportList()
			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie
				this.wMSReportASNReportList()
			},
		}
	}
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		height: 138px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 70px;
		transition: all 0.3s;
		overflow: hidden;
	}

	.inputtops {
		width: 980px;
		height: 80px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		padding-bottom: 64px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 10px;
		width: 100%;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 45px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 0px;
	}
</style>
